import * as e from "react";
const l = (t) => /* @__PURE__ */ e.createElement("svg", { xmlns: "http://www.w3.org/2000/svg", fill: "none", viewBox: "0 0 24 24", ...t }, /* @__PURE__ */ e.createElement("path", { fill: "#1f2830", d: "M3 1h7v22H3z" }), /* @__PURE__ */ e.createElement("path", { fill: "#1f2830", d: "M14 1h7v22h-7z" }));
export {
  l as default
};
